import { useRef } from "react"
import { makeStyles } from "@material-ui/core/styles"

import TextField from "@material-ui/core/TextField"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"

import ClearIcon from "@material-ui/icons/Clear"

const useStyles = makeStyles({
    clear: {
        position: "absolute",
        right: 0
    }
})

const SearchTextField = props => {
    const classes = useStyles()
    const input = useRef(null)

    function onClear() {
        if (input.current) {
            clearInput(input.current)
        }
    }

    return (
        <TextField
            {...props}
            inputProps={{
                ref: input
            }}
            InputProps={{
                endAdornment: props.value ? (
                    <InputAdornment position="end" className={classes.clear}>
                        <IconButton
                            tabIndex="-1"
                            edge="end"
                            color="primary"
                            onClick={onClear}
                            size="small"
                        >
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                ) : null
            }}
        />
    )
}

// https://stackoverflow.com/a/62111884/8062659
function clearInput(input) {
    const valueSetter = Object.getOwnPropertyDescriptor(input, "value")?.set
    const prototype = Object.getPrototypeOf(input)
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(
        prototype,
        "value"
    )?.set

    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(input, "")
    } else if (valueSetter) {
        valueSetter.call(input, "")
    }

    input.dispatchEvent(new Event("input", { bubbles: true }))
}

export default SearchTextField
